import banks from "../assets/data/banks.json"

export const getBankByName = (name: string) => {
  return banks.find(bank => bank.name === name)
}
